import request from '@/utils/request'


// 订单列表查询
export const queryOrderList = (params) => {
  return request({
    url: '/tinggoadmin/order/list',
    method: 'get',
    params
  })
}

// 订单详情查询
export const queryOrderDetail = (id) => {
  return request({
    url: `/tinggoadmin/order/detail/${id}`,
    method: 'get'
  })
}

// 订单状态变更
export const updateOrderStatus = (data) => {
  return request({
    url: '/tinggoadmin/order/updateStatus',
    method: 'put',
    data
  })
}

// 订单推送
export const pushOrder = (orderNo) => {
  return request({
    url: `/tinggoadmin/order/push/${orderNo}`,
    method: 'post'
  })
}

// 票号回填
export const fillTicketNo = (data) => {
  return request({
    url: '/tinggoadmin/order/fillTicketNo',
    method: 'post',
    data
  })
}

// 退票申请列表
export const queryRefundList = (params) => {
  return request({
    url: '/order/refund/list',
    method: 'get',
    params
  })
}

// 退票审批
export const approveRefund = (data) => {
  return request({
    url: '/order/refund/approve',
    method: 'post',
    data
  })
}

// 改签申请列表
export const queryChangeList = (params) => {
  return request({
    url: '/order/change/list',
    method: 'get',
    params
  })
}

// 改签审批
export const approveChange = (data) => {
  return request({
    url: '/order/change/approve',
    method: 'post',
    data
  })
}

// 退款申请
export const applyRefund = (data) => {
  return request({
    url: '/tinggoadmin/refund/apply',
    method: 'post',
    data
  })
}
